const convertDate = (date?: number): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date).toISOString().split("T")[0];
};
const convertDateBrComHora = (date?: number | string) => {
  if (date == undefined || date === "") {
    return "";
  }

  let parsed: Date;

  if (typeof date === "number") {
    parsed = new Date(date * 1000);
  } else {
    const raw = date.trim();
    if (/^\d{10}$/.test(raw)) {
      parsed = new Date(parseInt(raw, 10) * 1000);
    } else {
      parsed = new Date(raw);
    }
  }

  if (!Number.isFinite(parsed.getTime())) {
    return "";
  }

  const possuiHorario =
    parsed.getHours() !== 0 ||
    parsed.getMinutes() !== 0 ||
    parsed.getSeconds() !== 0;

  if (!possuiHorario) {
    return parsed.toLocaleDateString("pt-BR");
  }

  return parsed.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

const convertDateBr = (date?: number) => {
  if (date == undefined) {
    return "";
  }

  const myDate = new Date(date * 1000);
  return (
    myDate.getUTCDate() +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
  // return new Date(date * 1000).toLocaleDateString("en-GB");
};

const convertDateUs = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleDateString();
};

const convertStringDateToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }
  const raw = String(date);

  if (/^\d{10}$/.test(raw)) {
    const ts = parseInt(raw) * 1000;
    const d = new Date(ts);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  const onlyDate = raw.substring(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(onlyDate)) {
    const [y, m, d] = onlyDate.split("-");
    return `${d}/${m}/${y}`;
  }

  return new Date(raw).toLocaleDateString("pt-BR");
};
const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};
export {
  convertDate,
  convertDateIso,
  convertDateBr,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
  convertDateBrComHora,
};
